<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :footer="footer"
    :methods="methods"
    :config="config"
    @getList="getList"
  >
    <template #componentContainer>
      <order-tracker ref="showSatus" :statusId="statusId"></order-tracker>
    </template>
  </cTable>
</template>

<script>
import { getRefund } from "@/api/analysis/refundReport";
import { getAllClient } from "@/api/user/client";
import orderTracker from "@/base/tracker";
import cTable from "@/base/common/index";
// import format from "@/utils/format";
// import expandRow from "_my/table-expand";
export default {
  name: "refundReport",
  components: {
    cTable,
    orderTracker
  },
  methods: {
    getList(res) {
      // console.log(res, this);
      this.fields.forEach(field => {
        if (field.key === "refundSummary") {
          field.name =
            res.searchForm["startTime"] +
            "~" +
            res.searchForm["endTime"] +
            this.$t("refundSummary");
        }
      });
    }
  },
  data() {
    return {
      statusId: "",
      methods: {
        list: getRefund,
        getAllClient
      },
      config: {
        height: 630,
        merge: true
      },
      footer: { show: () => false },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            default() {
              return this.$page.format.dateFormat(
                new Date().setDate(1),
                "yyyy-MM-dd"
              );
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            default() {
              return this.$page.format.dateFormat(new Date(), "yyyy-MM-dd");
            },
            bind: {
              clearable: false,
              type: "date",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              format({ searchForm, value, newFormData }) {
                return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              }
              // "on-change"({ searchForm }) {
              //   let time = this.$page.format.timeFormat(searchForm.endTime);
              //   if (time.slice(-8) === "00:00:00") {
              //     time = time.split(" ")[0] + " " + "23:59:59";
              //     searchForm.endTime = time;
              //   }
              // }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getAllClient")
                ).payload.rows;
                this.$forceUpdate();
              }
            },
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              console.log(this);
              let data = this.$refs["header"].searchForm;
              console.log(this.$refs["header"].searchForm);
              data["export"] = 1;
              data["startTime"] = this.format.dateFormat(
                data["startTime"],
                "YYYY-MM-DD"
              );
              data["endTime"] = this.format.dateFormat(
                data["endTime"],
                "YYYY-MM-DD"
              );
              this.openLoading();
              this.handleRequestMethods("list", data, false, true).then(res => {
                console.log("res", res);
                window.open(this.$globalUrl + res.payload.src);
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$t("refundSummary"),
          key: "refundSummary",
          align: "center",
          children: [
            {
              name: () => this.$t("clientName"),
              key: "customer",
              align: "center",
              minWidth: 60
            },
            {
              name: () => this.$t("SetOriginalCurrency"),
              key: "to_country",
              align: "center",
              minWidth: 80
            },
            {
              name: () =>
                this.$t("refundAmount") +
                "（" +
                this.$t("generateBills") +
                "）",
              key: "generateBills",
              align: "center",
              children: [
                {
                  name: () => this.$t("Votes"),
                  key: "refund_count",
                  align: "center",
                  minWidth: 80
                },
                {
                  name: () => this.$t("codAmount"),
                  key: "refund_cod",
                  align: "center",
                  minWidth: 100
                },
                {
                  name: () => this.$t("refundHandlingFee") + "(USD)",
                  key: "refund_charge",
                  align: "center",
                  minWidth: 80
                },
                {
                  name: () => this.$t("refundAmount") + "(USD)",
                  key: "refundAmount",
                  align: "center",
                  children: [
                    {
                      name: () => this.$t("WrittenOff"),
                      key: "refund_9_usd",
                      align: "center",
                      minWidth: 100
                    },
                    {
                      name: () => this.$t("NotWrittenOff"),
                      key: "refund_1_usd",
                      align: "center",
                      minWidth: 100
                    }
                  ]
                }
              ]
            },
            {
              name: () =>
                this.$t("UnrefundedAmount") +
                "（" +
                this.$t("UngeneratedBills") +
                "）" +
                "【" +
                this.$t("PodAlready") +
                "】",
              key: "UngeneratedBills",
              align: "center",
              children: [
                {
                  name: () => this.$t("Votes"),
                  key: "not_refund_count",
                  align: "center",
                  minWidth: 80
                },
                {
                  name: () => this.$t("codAmount"),
                  key: "not_refund_cod",
                  align: "center",
                  minWidth: 100
                },
                {
                  name: () => this.$t("codAmount") + "(USD)",
                  key: "not_refund_usd",
                  align: "center",
                  minWidth: 80
                }
              ]
            },
            {
              name: () => this.$t("refundtotal"),
              key: "refundtotal",
              align: "center",
              children: [
                {
                  name: () => this.$t("codAmount"),
                  key: "all_refund_cod",
                  align: "center",
                  minWidth: 100
                },
                {
                  name: () => this.$t("refundAmount") + "(USD)",
                  key: "all_refund_usd",
                  align: "center",
                  minWidth: 100
                }
              ]
            }
          ]
        }
      ]
    };
  },
  mounted() {}
};
</script>
